import { Components, Theme } from "@mui/material";

export const MuiSelect: Components<Omit<Theme, "MuiSelect">>["MuiSelect"] = {
  defaultProps: {
    MenuProps: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left",
      },
      PaperProps: {
        style: {
          maxHeight: 300,
        },
      },
    },
  },
  styleOverrides: {
    root: ({ ownerState, theme: { spacing } }) => {
      const color = ownerState.color || "primary";
      const size = ownerState.size || "medium";

      return {
        backgroundColor: color === "secondary" ? "#F5F5F5" : "#FFFFFF",
        ...(size === "small" && { minHeight: 32 }),
        paddingRight: spacing(1),
        "& select": {
          paddingTop: spacing(1.6),
        },
      };
    },
    select: {
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
    filled: {
      height: "auto",
      padding: "2px 16px 2px",
      lineHeight: 1.5,
      marginRight: 24,
    },
    icon: {
      top: "calc(50% - 12px)",
      transition: "transform 150ms ease",
    },
    iconOpen: {
      transform: "rotate(180deg)",
    },
  },
};
